import React from "react";
import Slider from "react-slick";

const HomeEstimates = () => {
  const homes = [
    {
      image: "./images/home/minimalist-office-interior-design.jpg", // Replace with actual image URL
      title: "Office Interiors",
      description: "Designing elegant, cozy homes that reflect your style and meet your comfort needs.",
    },
    {
      image: "./images/office/home/Dining-area.jpg", // Replace with actual image URL
      title: "Home Interiors",
      description: "Designing elegant, cozy homes that reflect your style and meet your comfort needs.",
    },
    {
      image: "./images/home/room-house-decorated-with-brazilian-folklore-design.jpg", // Replace with actual image URL
      title: "Shop Interiors",
      description: "Creating visually engaging and functional shop interiors that attract customers and drive sales.",
    },
    {
      image: "./images/home/cozy-lively-home-interior-design.jpg", // Add more items as needed
      title: "Furniture Solutions",
      description: "Offering customized furniture solutions that perfectly blend style, comfort, and ......",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="home-estimates">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="estimates-title">Our Services</h2>
            <p className="estimates-subtitle">
              Choose your preferred style and sit back while our estimator does its magic
            </p>
          </div>
          <button className="btn btn-primary">GET STARTED</button>
        </div>

        <Slider {...settings}>
          {homes.map((home, index) => (
            <div key={index} className="p-3">
              <div className="card home-card">
                <img
                  src={home.image}
                  className="card-img-top"
                  alt={home.title}
                />
                <div className="card-body">
                  <h5 className="card-title">{home.title}</h5>
                  <p className="card-text">{home.description}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default HomeEstimates;
